import api from './';

export const relatorios = (caminho, url, obj = {}) =>
    api.post(`/relatorios/${caminho}/?${url.toString()}`, obj, { responseType: 'arraybuffer' });
